export const REQUEST_GROUPING_LEVELS = 'data/REQUEST_GROUPING_LEVELS';
export const RECEIVE_GROUPING_LEVELS = 'data/RECEIVE_GROUPING_LEVELS';

export const REQUEST_BUCKET_LEVELS = 'data/REQUEST_BUCKET_LEVELS';
export const RECEIVE_BUCKET_LEVELS = 'data/RECEIVE_BUCKET_LEVELS';


export const REQUEST_ENTITIES = 'data/REQUEST_ENTITIES';
export const RECEIVE_ENTITIES = 'data/RECEIVE_ENTITIES';
